<template>
  <div class="form-group bs-form-group">
    <select class="w-auto custom-select custom-select-sm border-0 text-uppercase font-size-sm font-weight-bold text-white" :class="innerClass" v-model="inputValue">
      <slot></slot>
    </select>
  </div>
</template>

<script>
export default {
  name: 'BadgeSelect',
  props: ['label', 'name', 'value', 'default', 'innerClass'],
  computed: {
    inputValue: {
      get () {
        return this.value ?? this.default
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  mounted () {
    this.$emit('input', this.value ?? this.default)
  },
  watch: {
    default () {
      this.$emit('input', this.default)
    }
  }
}
</script>
